module.exports = __webpack_public_path__ + "img/sigma10.a5d9e4cc.jpg";